/**
 * Ryan O'Dowd
 * 2024-12-07
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Animated,
  Platform,
  View,
} from 'react-native';
import React, {
  useEffect,
  useRef,
  useState,
} from 'react';
import getStyles from './styles';
import hooks from '@hooks';

// forked from react-native-elements
// https://reactnativeelements.com/docs/components/skeleton
// https://github.com/react-native-elements/react-native-elements/blob/next/packages/base/src/Skeleton/Skeleton.tsx
const Skeleton = (props: SkeletonProps) => {
  const styles = hooks.useStyles(getStyles);

  const animationRef = useRef(new Animated.Value(0));
  const animationLoop = useRef(undefined);

  const [layoutWidth, setLayoutWidth] = useState(0);

  useEffect(() => {
    animationLoop.current = Animated.timing(animationRef.current, {
      toValue: 2,
      delay: 300,
      duration: 1700,
      useNativeDriver: !!Platform.select({
        web: false,
        native: true,
      }),
    });
    animationRef.current.setValue(0);
    Animated.loop(animationLoop.current).start();
  }, []);

  return (
    <View
      onLayout={({nativeEvent}) => {
        setLayoutWidth(nativeEvent.layout.width);
      }}
      style={[
        styles.container,
        props.heading && styles.heading,
        props.firstLine && styles.firstLine,
        props.lastLine && styles.lastLine,
        Array.isArray(props.style)
          ? [...props.style]
          : props.style,
      ]}
    >
      <Animated.View
        style={[
          styles.skeleton,
          {
            transform: [
              {
                translateX: animationRef.current.interpolate({
                  inputRange: [0, 2],
                  outputRange: [-layoutWidth * 2, layoutWidth * 2],
                }),
              },
            ],
          },
        ]}
      />
    </View>
  );
};

class SkeletonProps {
  style?: any;
  heading?: boolean;
  firstLine?: boolean;
  lastLine?: boolean;
};

export default Skeleton;
